import PropTypes from 'prop-types';
import React from 'react';
import { getIndicatorColor } from '../costBenchmarkHelpers.js';
import { DEFAULT } from '../costBenchmarkTexts.js';

const LegendItem = ({ label, color = DEFAULT }) => {

  return (
    <div className="legend-item">
      <span className={`dot-indicator ${getIndicatorColor(color)}`}></span>
      {label}
    </div>
  );
};

LegendItem.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string
};

export default LegendItem;
